var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 .254a11 11 0 1 0 11 11 11.01 11.01 0 0 0-11-11m0 20.534a9.534 9.534 0 1 1 9.533-9.534A9.545 9.545 0 0 1 11 20.788"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.282a.73.73 0 0 0-.733.734v7.395a.733.733 0 0 0 1.466 0V6.016A.73.73 0 0 0 11 5.282M10.856 15.774a.746.746 0 0 0-.375.202.733.733 0 0 0 .668 1.236.7.7 0 0 0 .376-.2.733.733 0 0 0-.663-1.238z"
  })));
};
export default SvgInfo;